import MaterialSummaries from "./MaterialSummaries";

export default MaterialSummaries;
